<template>
    <kgr-address-map
        :locations="locations"
        :base-location="baseLocation"
        :current-pin-id="currentPinId"
        :zoom="zoom"
        :api-key="apiKey"
        @mapsDisabled="disableMap()"
        @mapsEnabled="enableMap()"
    />
</template>

<script>
import AddressMap from '../map/AddressMap.vue';

export default {
    components: {
        'kgr-address-map': AddressMap,
    },
    props: {
        locations: {
            type: Object,
            required: true,
        },
        baseLocation: {
            type: Object,
            required: false,
            default: null,
        },
        zoom: {
            type: Number,
            required: false,
            default: 13,
        },
        apiKey: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            currentPinId: null,
        }
    },
    mounted() {
        window.kgr.legacyAddressMapCurrentPinId = null;

    },
    destroyed() {
        if(this.externalPinListener !== undefined) {
            clearInterval(this.externalPinListener);
        }
    },
    methods: {
        disableMap() {
            window.kgr.legacyAddressMapCurrentPinId = null;
            this.currentPinId = null;
            clearInterval(this.externalPinListener);
        },
        enableMap() {
            // listen periodically for changes in window.kgr.legacyAddressMapCurrentPinId
            this.externalPinListener = setInterval(() => {
                this.currentPinId = window.kgr.legacyAddressMapCurrentPinId ?? null;
            }, 200);
        },
    },
}
</script>
